// RenderErrorMessage.js
import RoundedButton from 'components/Button'
import { ErrorContainer, ErrorTitle, ErrorMessage } from '../style'
import { ReportProblem } from '@material-ui/icons'

export const RenderErrorMessage = (
  errorMessage,
  handleNewImport,
  handleRetry
) => {
  return (
    <ErrorContainer>
      <ReportProblem
        color="error"
        style={{ fontSize: 48, marginBottom: '16px' }}
      />
      <ErrorTitle>Erro no Processamento</ErrorTitle>
      <ErrorMessage>{errorMessage}</ErrorMessage>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          marginTop: '20px',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        <RoundedButton
          type="reload"
          size="large"
          variant="contained"
          onClick={handleNewImport}
          text="Começar de Novo"
        />
        <RoundedButton
          size="large"
          variant="outlined"
          color="primary"
          onClick={handleRetry}
          text="Tentar Novamente"
        />
      </div>
    </ErrorContainer>
  )
}
